import React from 'react';
import { CheckIcon, InfoIcon, WarningIcon } from './icons';

const cx = (...names) => names.filter(Boolean).join(' ');
const ICONS = { info: InfoIcon, success: CheckIcon, warning: WarningIcon, danger: WarningIcon };

/**
 * A message inside a page or a dialog (not a toast): info, success, warning
 * (amber) or danger. Errors are announced (role="alert"), the others
 * politely (role="status"), unless `role` says otherwise.
 */
export function Alert({ tone = 'info', title, children, role, action, className, ...rest }) {
  const Icon = ICONS[tone] || InfoIcon;
  return (
    <div role={role === undefined ? (tone === 'danger' ? 'alert' : 'status') : role || undefined}
         className={cx('ui-alert', `ui-alert--${tone}`, className)} {...rest}>
      <Icon size={18} className="ui-alert__icon" />
      <div className="ui-alert__body">
        {title && <p className="ui-alert__title">{title}</p>}
        {children}
      </div>
      {action && <div className="ui-alert__action">{action}</div>}
    </div>
  );
}

export default Alert;
